import { types } from "../types/simulation";

export function loadSimulationJob(payload) {
  return {
    type: types.LOAD_SIMULATION_JOB,
    payload,
  };
}
